import styled from "styled-components";
import { deviceQuery } from "../../../styles/mediaSizes"

export const StyledCardHeader = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 1.5rem 2rem;

  @media ${deviceQuery.mobileL} {
    padding: 2rem 0.5rem;
  }

  .detailsWrap {
    display: flex;
    align-items: flex-start;
    flex-grow: 1;

    .nameWrap {
      margin-left: 1rem;
      flex-grow: 1;

      .projectName {
        color: ${({ theme }) => theme.palette.common.text.primary};
        font-size: 2rem;
        font-weight: 850;
        line-spacing: 24px;
        letter-spacing: 0.5px;
        margin-bottom: 0px;
      }
      .desc {
        color: ${({ theme }) => theme.palette.card.text.primary};
      }
    }

    .status {
      min-width: 9rem;
      background-color: ${({ theme }) => theme.palette.card.text.primary};
      border-radius: 1.5rem;
      display: flex;
      justify-content: center;
      position: relative;
      & > p {
        color: black;
        margin: 0;
        font-size: 1.2rem;
        display: flex;
        align-items: center;
        /* &::before {
          content: "";
          width: 6px;
          height: 6px;
          display: block;
          margin-right: 3px;
          border-radius: 50%;
          background-color: white;
        } */
      }
    }
        .pulse {
          width: 6px;
          height: 6px;
          display: block;
          margin-right: 6px;
          margin-top: 5px;
          border-radius: 50%;
          background-color: white;
          animation: animate 2.5s linear infinite;
        }

        @keyframes animate {
          0% {
            box-shadow: 0 0 0 0 rgba(30, 130, 76, 1) ,
              0 0 0 0 rgba(30, 130, 76, 1) ;
          }

          40% {
            box-shadow: 0 0 0 5px rgba(30, 130, 76, 0.3) ,
              0 0 0 0 rgba(30, 130, 76, .7) ;
          }

          80% {
            box-shadow: 0 0 0 5px rgba(30, 130, 76, 0.2) ,
              0 0 0 2px rgba(30, 130, 76, 0.2) ;
          }

          100% {
            box-shadow: 0 0 0 0 rgba(30, 130, 76, 0) ,
              0 0 0 2px rgba(30, 130, 76, 0) ;
          }
  }
`;
